"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const notifySessionExpired_1 = __importDefault(require("../actions/signin/notifySessionExpired"));
const store_1 = __importDefault(require("../store"));
const authClient_1 = require("../utils/authClient");
const ONE_MINUTE_MILLIS = 60 * 1000;
class SessionExpirationHandler {
    constructor() {
        this.startSession = () => {
            this.reset();
            this.handleSessionExpiry();
        };
        this.handleSessionExpiry = () => {
            const durationUntilSessionExpiresMs = authClient_1.getTimeUntilSessionExpiryMs();
            if (durationUntilSessionExpiresMs) {
                const durationUntilLogoutMs = durationUntilSessionExpiresMs - ONE_MINUTE_MILLIS;
                // If when the session starts there is < 5 minutes remaining, log the user out now and force them to renew
                // their session
                if (durationUntilLogoutMs <= 5 * ONE_MINUTE_MILLIS) {
                    this.logoutAndReset();
                }
                else {
                    // Log the user out 1 minute before their session expires
                    this.timeout = setTimeout(() => this.logoutAndReset(), durationUntilLogoutMs);
                }
            }
        };
        this.logoutAndReset = () => __awaiter(this, void 0, void 0, function* () {
            yield store_1.default.dispatch(notifySessionExpired_1.default());
            this.reset();
        });
        this.reset = () => {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = undefined;
            }
        };
    }
}
const handler = new SessionExpirationHandler();
exports.default = handler;
